export default () => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.167 3.5c-5.799 0-10.5 4.702-10.5 10.5h-3.5l4.538 4.538.082.164L10.5 14H7a8.16 8.16 0 0 1 8.167-8.167A8.16 8.16 0 0 1 23.333 14a8.16 8.16 0 0 1-8.166 8.167 8.1 8.1 0 0 1-5.764-2.404L7.747 21.42a10.447 10.447 0 0 0 7.42 3.08c5.798 0 10.5-4.702 10.5-10.5s-4.702-10.5-10.5-10.5zM14 9.333v5.834l4.993 2.963.84-1.412-4.083-2.426V9.333H14z"
			fill="#367BF5"
		/>
	</svg>
);
